import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useEffect, useState } from 'react';
import ScenarioTable from '../../_components/organisms/ScenariosTable';
import {
  // Button,
  CardComponent,
  PageTitleAndSubTitle,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { useStores } from '../../stores';
import useSnackbar from '../../core-utils/custom-hooks/Snackbar';
import {
  deleteScenario,
  duplicateScenario,
  fetchScenarios,
} from '../../core-utils/axios/financials/scenarios';
import {
  formatDate,
  Scenario,
  scenarioColumns,
} from '../../core-utils/helper-utils/buildScenarioHelper';
import Loader from '../../_components/molecules/Loader';
// import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import GifWithLabels from '@HomaHealth/ui-component-library/lib/_patient-access-components/molecules/GIFWithLabels';
import EmptyDataVisual from '../../../public/Images/FFEmptyData.png';
import { Pagination } from '@mui/material';
import Snackbar from '../../_components/atoms/Snackbar';
import { SCENARIO_WORKSPACE } from '../../core-utils/routes';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles()({
  root: {
    width: '1182px',
    padding: '40px 0px 66px 63px',
  },
  header: {
    padding: '0px 0px 29px 0px',
  },
  divider: {
    borderBottom: '1px solid ' + patientAccessTheme.palette.grey[300],
  },
  body: {
    padding: '36px 0px 0px 0px',
  },
  table: {
    padding: '28px 0px 0px 0px',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'right',
    marginTop: '16px',
  },
});

const ScenarioLibrary = () => {
  //Constants
  const { classes } = useStyles();
  const employerGroupStore = useStores().employerGroupStore;
  //   const loginStore = useStores().loginPageStore;
  const egNid = employerGroupStore.employerGroupResponseData.eg_nid[0];
  const navigate = useNavigate();
  const fiscalControlStore = useStores().fiscalControlStore;

  //   const email = loginStore?.email;
  const { snackbarState, handleCloseSnackBar, openSnackbar } = useSnackbar();

  //UseStates
  const [loading, setLoading] = useState<boolean>(true);
  const [scenarios, setScenarios] = useState<Scenario[]>([]);
   
  const [selectedScenarios, setSelectedScenarios] = useState<Scenario[]>([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);

  //Functions
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setPageNumber(value);
  };

  const handleSelectRows = (selectRows: any[]) => {
    setSelectedScenarios(selectRows);
  };

  const handleMenuItemClick = async (menu: string, row: Scenario) => {
    switch (menu) {
      case 'Edit':
        const startDate = new Date(row?.planStartDate)
          .toISOString()
          .split('T')[0];
        const endDate = new Date(row?.planEndDate).toISOString().split('T')[0];
        fiscalControlStore.setStartDate(startDate);
        fiscalControlStore.setEndDate(endDate);
        fiscalControlStore.setSelectedDateRange(
          JSON.stringify({ startDate, endDate }),
        );

        navigate(SCENARIO_WORKSPACE);
        break;
      case 'Delete':
        await deleteScenario(row?._id, openSnackbar);
        await getScenarios();
        break;
      case 'Duplicate':
        await duplicateScenario(row?._id, openSnackbar);
        await getScenarios();
        break;
    }
  };

  //Axios
  const getScenarios = async () => {
    setLoading(true);
    const data = await fetchScenarios(
      egNid,
      undefined,
      undefined,
      pageNumber,
      10,
      openSnackbar,
    );
    const fetchedScenarios = data?.scenarios;
    setTotalPages(data?.totalPages);
    setScenarios(
      fetchedScenarios?.map((item: Scenario) => ({
        ...item,
        baseLineYear: `${formatDate(item?.planStartDate)} - ${formatDate(
          item?.planEndDate,
        )}`,
        totalCost: Number(item?.totalFixedCost + item?.totalVariableCost),
      })),
    );
    setLoading(false);
  };

  //UseEffects
  useEffect(() => {
    if (!egNid) {
      return;
    }
    getScenarios();
  }, [pageNumber, egNid]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Grid className={classes.root}>
          <Grid className={classes.header}>
            <PageTitleAndSubTitle title={'Scenario Library'} subTitle={''} />
          </Grid>
          <Grid className={classes.divider}></Grid>
          <Grid className={classes.body}>
            <CardComponent
              title={'List of Scenarios'}
              body={
                <Grid className={classes.table}>
                  {scenarios?.length > 0 ? (
                    <Grid>
                      <ScenarioTable
                        data={scenarios}
                        columns={scenarioColumns}
                        height="400px"
                        onSelectionChange={handleSelectRows}
                        handleMenuItemClick={handleMenuItemClick}
                      />
                      <div className={classes.pagination}>
                        <Pagination
                          page={pageNumber}
                          count={totalPages}
                          onChange={handlePageChange}
                          size="small"
                          color="primary"
                        />
                      </div>
                    </Grid>
                  ) : (
                    <GifWithLabels
                      mainLabel={undefined}
                      subLabel={
                        'Nothing here yet — create a scenario to begin your cost planning journey.'
                      }
                      gifUrl={EmptyDataVisual}
                    />
                  )}
                </Grid>
              }
              // topRightItem={
              //   scenarios?.length > 0 ? (
              //     <Button
              //       label={'Compare Scenarios'}
              //       variant="contained"
              //       height="37px"
              //       width="auto"
              //       onClick={() => {}}
              //       disabled={selectedScenarios?.length === 0}
              //     />
              //   ) : (
              //     <></>
              //   )
              // }
            />
          </Grid>
        </Grid>
      )}
      <Snackbar
        {...snackbarState}
        vertical={'bottom'}
        horizontal={'right'}
        handleClose={handleCloseSnackBar}
      />
    </>
  );
};

export default ScenarioLibrary;
